'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reduxForm = require('redux-form');

var _widgetValidation = require('./widgetValidation');

var _widgetValidation2 = _interopRequireDefault(_widgetValidation);

var _widgets = require('redux/modules/widgets');

var widgetActions = _interopRequireWildcard(_widgets);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  WidgetForm: {
    displayName: 'WidgetForm'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/WidgetForm/WidgetForm.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var WidgetForm = _wrapComponent('WidgetForm')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    saveError: state.widgets.saveError
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)(widgetActions, dispatch);
}), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'widget',
  fields: ['id', 'color', 'sprocketCount', 'owner'],
  validate: _widgetValidation2.default
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(WidgetForm, _Component);

  function WidgetForm() {
    (0, _classCallCheck3.default)(this, WidgetForm);
    return (0, _possibleConstructorReturn3.default)(this, (WidgetForm.__proto__ || (0, _getPrototypeOf2.default)(WidgetForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(WidgetForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          editStop = _props.editStop,
          _props$fields = _props.fields,
          id = _props$fields.id,
          color = _props$fields.color,
          sprocketCount = _props$fields.sprocketCount,
          owner = _props$fields.owner,
          formKey = _props.formKey,
          handleSubmit = _props.handleSubmit,
          invalid = _props.invalid,
          pristine = _props.pristine,
          save = _props.save,
          submitting = _props.submitting,
          saveError = _props.saveError[formKey],
          values = _props.values;

      var styles = require('containers/Widgets/Widgets.scss');
      return _react3.default.createElement(
        'tr',
        { className: submitting ? styles.saving : '' },
        _react3.default.createElement(
          'td',
          { className: styles.idCol },
          id.value
        ),
        _react3.default.createElement(
          'td',
          { className: styles.colorCol },
          _react3.default.createElement(
            'select',
            (0, _extends3.default)({ name: 'color', className: 'form-control' }, color),
            _widgetValidation.colors.map(function (valueColor) {
              return _react3.default.createElement(
                'option',
                { value: valueColor, key: valueColor },
                valueColor
              );
            })
          ),
          color.error && color.touched && _react3.default.createElement(
            'div',
            { className: 'text-danger' },
            color.error
          )
        ),
        _react3.default.createElement(
          'td',
          { className: styles.sprocketsCol },
          _react3.default.createElement('input', (0, _extends3.default)({ type: 'text', className: 'form-control' }, sprocketCount)),
          sprocketCount.error && sprocketCount.touched && _react3.default.createElement(
            'div',
            { className: 'text-danger' },
            sprocketCount.error
          )
        ),
        _react3.default.createElement(
          'td',
          { className: styles.ownerCol },
          _react3.default.createElement('input', (0, _extends3.default)({ type: 'text', className: 'form-control' }, owner)),
          owner.error && owner.touched && _react3.default.createElement(
            'div',
            { className: 'text-danger' },
            owner.error
          )
        ),
        _react3.default.createElement(
          'td',
          { className: styles.buttonCol },
          _react3.default.createElement(
            'button',
            { className: 'btn btn-default',
              onClick: function onClick() {
                return editStop(formKey);
              },
              disabled: submitting },
            _react3.default.createElement('i', { className: 'fa fa-ban' }),
            ' Cancel'
          ),
          _react3.default.createElement(
            'button',
            { className: 'btn btn-success',
              onClick: handleSubmit(function () {
                return save(values).then(function (result) {
                  if (result && (0, _typeof3.default)(result.error) === 'object') {
                    return _promise2.default.reject(result.error);
                  }
                });
              }),
              disabled: pristine || invalid || submitting },
            _react3.default.createElement('i', { className: 'fa ' + (submitting ? 'fa-cog fa-spin' : 'fa-cloud') }),
            ' Save'
          ),
          saveError && _react3.default.createElement(
            'div',
            { className: 'text-danger' },
            saveError
          )
        )
      );
    }
  }]);
  return WidgetForm;
}(_react2.Component), _class2.propTypes = {
  fields: _react2.PropTypes.object.isRequired,
  editStop: _react2.PropTypes.func.isRequired,
  handleSubmit: _react2.PropTypes.func.isRequired,
  invalid: _react2.PropTypes.bool.isRequired,
  pristine: _react2.PropTypes.bool.isRequired,
  save: _react2.PropTypes.func.isRequired,
  submitting: _react2.PropTypes.bool.isRequired,
  saveError: _react2.PropTypes.object,
  formKey: _react2.PropTypes.string.isRequired,
  values: _react2.PropTypes.object.isRequired
}, _temp)) || _class) || _class));

exports.default = WidgetForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/WidgetForm/WidgetForm.js
// module id = 1200
// module chunks = 0